import { LoadingStatusType } from "@/enums/enums";
import { UserId } from "@/helper/userHelper";
import UserService from "@/service/user/userService";
import store from "@/store/index";
import { Action, Module, Mutation, VuexModule } from "vuex-module-decorators";
@Module({ namespaced: true })
export default class User extends VuexModule {
  public userInApp: any = null;
  public userInAppLoadingStatus = LoadingStatusType.None;

  @Mutation
  public MutationSetUserInApp(userInApp: any): void {
    this.userInApp = userInApp;
  }

  @Mutation
  public MutationUserInAppLoadingStatus(status: LoadingStatusType): void {
    this.userInAppLoadingStatus = status;
  }
  @Action
  public DoGetUserInApp() {
    const merchant = store.getters["LogIn/getMerchant"];
    const userInApp = {
      merchantId: merchant.merchant.merchantId,
      userId: UserId(),
      merchantCreateDateTime: merchant.merchant.createDateTime,
      joinMerchantDateTime: merchant.merchant.joinMerchantDateTime,
    };
    this.context.commit("MutationUserInAppLoadingStatus", LoadingStatusType.Loading);
    UserService.DoGetUserInAppPEAKBoard(userInApp).then((res: any) => {
      if (res.responseCode.IsSuccess()) {
        this.context.commit("MutationUserInAppLoadingStatus", LoadingStatusType.Success);
        this.context.commit("MutationSetUserInApp", res.userInAppSuggestion);
      } else {
        this.context.commit("MutationUserInAppLoadingStatus", LoadingStatusType.Fail);
      }
    });
  }

  get getUserInApp(): any {
    return this.userInApp;
  }
  get getUserInAppLoadingStatus(): any {
    return this.userInAppLoadingStatus;
  }
}
